export interface PaginationState {
  pageNumber: number;
  pageSize: number;
}

export const initialState: PaginationState = {
  pageNumber: 1,
  pageSize: 10,
};
